export default {"src":"/_next/static/media/check-circle.0a524ef9.svg","height":28,"width":28};